import BalanceSummaryIcon from './BalanceSummaryIcon';

export default BalanceSummaryIcon;
